<template>
  <el-row>
    <el-col
      :md="12"
      style="text-align: center;"
    >
      <b class="mb-8">Contact</b>
      <br>
      <br>
      <el-form
        ref="form"
        :model="enquiry.requester"
        label-width="120px"
        size="small"
      >
        <el-row>
          <el-col :md="10">
            <el-form-item label="Name">
              <el-input v-model="enquiry.requester.name" />
            </el-form-item>
          </el-col>
          <el-col :md="10">
            <el-form-item label="Mobile">
              <el-input v-model="enquiry.requester.mobile" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="10">
            <el-form-item label="Phone">
              <el-input v-model="enquiry.requester.phone" />
            </el-form-item>
          </el-col>
          <el-col :md="10">
            <el-form-item label="Email">
              <el-input v-model="enquiry.requester.email" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-col>
    <el-col
      :md="12"
      style="text-align: center;"
    >
      <b class="pb-4">Enquiry Details</b>
      <br>
      <br>
      <el-form
        ref="form"
        :model="enquiry"
        label-width="120px"
        size="small"
      >
        <el-row>
          <el-col :md="10">
            <el-form-item label="Status">
              <el-select
                v-model="enquiry.status"
                placeholder="Select a status"
                style="display: inline;"
              >
                <el-option
                  label="Open"
                  :value="2"
                />
                <el-option
                  label="Pending"
                  :value="3"
                />
                <el-option
                  label="Resolved"
                  :value="4"
                />
                <el-option
                  label="Closed"
                  :value="5"
                />
                <el-option
                  label="Closed (Non-Enquiry)"
                  :value="12"
                />
                <el-option
                  label="Pickups"
                  :value="10"
                />
                <el-option
                  label="Waiting on Customer"
                  :value="6"
                />
                <el-option
                  label="Open (Child)"
                  :value="14"
                />
                <el-option
                  label="Waiting on Third Party"
                  :value="7"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="10">
            <el-form-item label="Priority">
              <el-select
                v-model="enquiry.priority"
                placeholder="Select a priority"
              >
                <el-option
                  label="Low"
                  :value="1"
                />
                <el-option
                  label="Medium"
                  :value="2"
                />
                <el-option
                  label="High"
                  :value="3"
                />
                <el-option
                  label="Urgent"
                  :value="4"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="10">
            <el-form-item label="Opened At">
              <el-input v-model="enquiry.created_at" />
            </el-form-item>
          </el-col>
          <el-col :md="10">
            <el-button
              icon="el-icon-view"
              type="primary"
              style="margin-left: 54px;"
              size="small"
              @click.native="openInFreshDesk"
            >
              View in FreshDesk
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-col>
  </el-row>
</template>
<script>
export default {
  props: {
    enquiry: {
      type: Object,
      required: true
    }
  },
  methods: {
    openInFreshDesk () {
      window.open('https://tigfreightmanagement.freshdesk.com/a/tickets/' + this.enquiry.id)
    },
    getStatusText (code) {
      switch (code) {
        case 2:
        case 3:
          return 1
        default:
          return 2
      }
    }
  }
}
</script>
